import { useRef, useState } from "react";
import { FaThumbsUp } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { TbDotsVertical } from "react-icons/tb";
import { FaRegEye, FaTrashAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { HiMiniSpeakerWave, HiMiniSpeakerXMark } from "react-icons/hi2";
import { formatCount } from "../../utils/formatCount";
import { isOwnLikeCountHidden } from "../../utils/userPreferences";

export default function VideoCard({
    id,
    likes_count,
    body,
    video,
    avatar_url,
    authorId,
    handleDeletePost,
    removeVideoFromlist,
    handleMoveVideo,
    handleEnterSelectionMode,
    threeDots,
    belowDecs,
    selectVideo,
    view_count,
    isSavedView,
    isSavedList,
    hideSound,
    showDelete,
    thumbnail,
    onDeleteClick,
    selectionMode,
    isSelected,
    onToggleSelection,
    showSelectOption = true,
    showMoveOption = true,
    showRemoveOption = false,
    removeOptionLabel = "Remove"
}) {
    const navigate = useNavigate();
    const currentUserId = useSelector((state) => state.AccountProfile?.User_profile?.id);
    // Only hide the like count when this particular video was posted by the
    // logged-in user themselves — other creators' videos (e.g. reposted,
    // saved, or liked content) keep their real like count visible.
    const hideLikeCount = isOwnLikeCountHidden(authorId, currentUserId);
    const menuRef = useRef(null);
    const savedPopupRef = useRef(null);
    const [postId, setpostId] = useState(null);
    const [sound, setSound] = useState(true);
    const [hovered, setHovered] = useState(false);
    const [showSavedPopup, setShowSavedPopup] = useState(false);

    const videoRef = useRef();

    const handleMouseEnter = () => {
        if (videoRef.current) {
            const playPromise = videoRef.current.play();
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    // Auto-play was prevented
                    // Show a UI element to let the user manually start playback
                });
            }
        }
    };

    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    const handleClickOutside = () => {
        setpostId(null);
        setShowSavedPopup(false);
    };

    const handleNavigate = () => {
        if (!selectionMode) {
            selectVideo(id);
        } else {
            onToggleSelection && onToggleSelection(id);
        }
    }

    useOutsideClick(menuRef, handleClickOutside);
    useOutsideClick(savedPopupRef, handleClickOutside);

    return (
        <div
            key={id}
            className={`col-span-1 ${!belowDecs ? "flex flex-col-reverse gap-1" : ""}`}
        >
            <div
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                className="h-[20vh] w-[100%] relative rounded-md overflow-hidden"
            >
                <div
                    onClick={() => handleNavigate()}
                    className="w-full h-full rounded-md group relative"
                >
                    {thumbnail ? (
                        <img
                            src={thumbnail}
                            alt="Video thumbnail"
                            className="h-full w-full object-cover rounded-md cursor-pointer border border-gray-300 dark:border-gray-800/50 transition duration-500 group-hover:scale-105"
                        />
                    ) : (
                        <video
                            muted={sound}
                            ref={videoRef}
                            src={`${video}`}
                            autoPlay={hovered}
                            disablePictureInPicture
                            // onClick={() => selectVideo(id)}
                            controlsList="nodownload noremoteplayback"
                            className="h-full w-full object-cover rounded-md cursor-pointer border border-gray-300 dark:border-gray-800/50 transition duration-500 group-hover:scale-105"
                        />
                    )}
                    {isSavedView &&
                        <div
                            className="absolute -right-1 top-0 cursor-pointer z-40"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="relative">
                                {!selectionMode && (
                                    <>
                                        <div
                                            className="p-2"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setShowSavedPopup(!showSavedPopup);
                                            }}
                                        >
                                            <TbDotsVertical
                                                className="text-[16px] text-white drop-shadow-lg"
                                            />
                                        </div>
                                        {showSavedPopup &&
                                            <div
                                                ref={savedPopupRef}
                                                className="absolute top-2 right-5 bg-white rounded-md border border-gray-400 overflow-hidden z-[100] shadow-md min-w-[80px]"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {showSelectOption && (
                                                    <p
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (handleEnterSelectionMode) {
                                                                handleEnterSelectionMode(id);
                                                            }
                                                            setShowSavedPopup(false);
                                                        }}
                                                        className="text-[9px] px-1.5 py-1 hover:bg-gray-200 cursor-pointer"
                                                    >
                                                        Select
                                                    </p>
                                                )}

                                                {showMoveOption && (
                                                    <p
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleMoveVideo && handleMoveVideo(id);
                                                            setShowSavedPopup(false);
                                                        }}
                                                        className={`text-[9px] px-1.5 py-1 hover:bg-gray-200 cursor-pointer ${(showSelectOption || showRemoveOption) ? "border-t border-gray-200" : ""}`}
                                                    >
                                                        Move To Folder
                                                    </p>
                                                )}

                                                {showRemoveOption && (
                                                    <p
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDeletePost && handleDeletePost(id);
                                                            setShowSavedPopup(false);
                                                        }}
                                                        className={`text-[9px] px-1.5 py-1 hover:bg-gray-200 cursor-pointer ${(showSelectOption || showMoveOption) ? "border-t border-gray-200" : ""}`}
                                                    >
                                                        {removeOptionLabel}
                                                    </p>
                                                )}
                                            </div>
                                        }
                                    </>
                                )}
                            </div>
                        </div>
                    }
                    {/* Selection mode checkbox */}
                    {selectionMode && (
                        <div
                            className="absolute top-2 right-2 z-40"
                            onClick={(e) => {
                                e.stopPropagation();
                                onToggleSelection && onToggleSelection(id);
                            }}
                        >
                            <div className={`w-5 h-5 rounded-md border-[3px] flex items-center justify-center cursor-pointer transition-all shadow-lg ${isSelected
                                ? 'bg-blue-500 border-blue-500'
                                : 'bg-white border-white'
                                }`}>
                                {isSelected && (
                                    <svg className="w-3 h-3 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M5 13l4 4L19 7"></path>
                                    </svg>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {showDelete && hovered && (
                    <div
                        className="absolute top-2 right-2 z-10"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDeleteClick && onDeleteClick(id);
                        }}
                    >
                        <div className="rounded-full h-5 w-5 p-[2px] cursor-pointer flex justify-center items-center bg-white dark:bg-[#333333] opacity-75 hover:opacity-90">
                            <FaTrashAlt className="text-[10px] hover:text-red-500 cursor-pointer" />
                        </div>
                    </div>
                )}
                {/* {!hideSound && hovered && (
                    <div className="absolute top-2 left-2 z-10">
                        <div
                            className="rounded-full h-5 w-5 p-[2px] cursor-pointer flex justify-center items-center bg-white dark:bg-black dark:text-white opacity-75 hover:opacity-90"
                            onClick={(e) => {
                                e.stopPropagation();
                                setSound(!sound);
                            }}
                        >
                            {!sound ? (
                                <HiMiniSpeakerWave className="text-[15px]" />
                            ) : (
                                <HiMiniSpeakerXMark className="text-[15px]" />
                            )}
                        </div>
                    </div>
                )} */}
                <div className="absolute bottom-1 right-1">
                    <div className="flex items-center justify-end gap-x-1.5 right-0">
                        <p className="text-white text-[8px] mt-[1px]">{formatCount(view_count)}</p>
                        <FaRegEye className="text-[10px] text-white" />
                    </div>
                    {!hideLikeCount && (
                        <div className="flex justify-end gap-x-1.5">
                            <p className="text-white text-[8px]">{formatCount(likes_count)}</p>
                            <FaThumbsUp className="text-[10px] text-white" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}